export interface NavigationData {
  brand: {
    name: string
    href: string
  }
  navItems: {
    name: string
    href: string
    external?: boolean
  }[]
}

export const navigationData: NavigationData = {
  brand: {
    name: "Huangdi",
    href: "#home"
  },
  navItems: [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Contact', href: '#contact' },
    { name: 'Resume', href: 'https://drive.google.com/file/d/1Zu0cx8AUsRzdag4VVVSjjz61BVzLFr4z/view?usp=sharing', external: true }
  ]
} 